export default __webpack_public_path__ + "static/media/Image3_Tablet.4dc12eec.png";